import Vue from './vueconfig.js'
import VueRouter from 'vue-router'
import VueAnalytics from 'vue-analytics'
import VueGtm from 'vue-gtm'

import store from './store.js'
import prerender from './prerender.js'
import HomePage, { DISTINCT_CMS_PAGES } from '@/components/HomePage'
import ProjPage from '@/components/ProjPage'
import CheckoutPage from '@/components/CheckoutPage'
import MyBooksPage from '@/components/MyBooksPage'
import MyAccountPage from '@/components/MyAccountPage'
import GalleryPage from '@/components/GalleryPage'
import NotFoundPage from '@/components/NotFoundPage'

const DocViewerPage = () => import(/* webpackChunkName: "docs" */ './components/DocViewerPage.vue')
const SlugViewerPage = () => import(/* webpackChunkName: "docs" */ './components/SlugViewerPage.vue')
const SlugIndexPage = () => import(/* webpackChunkName: "docs" */ './components/SlugIndexPage.vue')
const DashboardPage = () => import(/* webpackChunkName: "admin" */ './admin/DashboardPage.vue')
const PhotobookConfigPage = () => import(/* webpackChunkName: "photo" */ './photobook/PhotobookConfigPage')
const ShopPage = () => import(/* webpackChunkName: "shop" */ './shop/ShopPage')

Vue.use(VueRouter);

function waitUser(to, from, next, count) {
  count = count || 1
  console.log('user check', to.path, store.state.uid)
  if (store.state.user.isDummy) {
    if (count < 20) {
      console.log('user check wait', count, to.path, store.state.uid)
      window.setTimeout(() => {waitUser(to, from, next, count+1)}, 100)
    } else {
      next('/?err=no-user')
    }
  } else {
    next();
  }
}

function impersonateAndRedirect(to, from, next) {
  console.log('impersonating en-route to',to.query.to)
  function impersonateNext(toOverride) {
    if (toOverride) { //prob user signin err
      next(toOverride)
    } else if (to.params.email) {
      store.commit('updateDevMode', true)
      
    } else if (store.state.dev.developmentClient && to.params.uid) {
      console.log('setting uid to',to.params.uid)
      store.commit('updateImpersonateUid', to.params.uid)
      window.setTimeout(() => next(to.query.to, 10))
    } else {
      next(false)
    }
  }
  return waitUser(to.query.to, from, impersonateNext)
}

const CMS_PATH = DISTINCT_CMS_PAGES.join('|')

const router = new VueRouter({
  mode: 'history',
  from: '/',
  routes: [
    { path: '/', component: HomePage },
    { path: '/:cms('+CMS_PATH+')-book', component: HomePage },
    { path: '/print-:cms('+CMS_PATH+')-book', component: HomePage },
    { path: '/print-:cms('+CMS_PATH+')-photobook', component: HomePage },
    { path: '/gallery/:bookid?', component: GalleryPage },
    { path: '/shop/:shopid', component: ShopPage },
    { path: '/shop/:shopid/:bookid', component: GalleryPage },
    { path: '/doc/:docid?', component: DocViewerPage },
    { path: '/journal/:docid?', component: DocViewerPage },
    { path: '/slug/:docid', component: SlugViewerPage },
    { path: '/slug', component: SlugIndexPage },
    { path: '/mybooks', component: MyBooksPage, beforeEnter: waitUser },
    { path: '/myaccount/:email?', component: MyAccountPage, beforeEnter: waitUser },
    { path: '/projects/:projid/:volid?', component: ProjPage, beforeEnter: waitUser },
    { path: '/preview/:projid/:volid?', component: ProjPage, beforeEnter: waitUser },
    { path: '/photobook/:projid', component: PhotobookConfigPage, beforeEnter: waitUser },
    { path: '/checkout', component: CheckoutPage, beforeEnter: waitUser },
    { path: '/dashboard', component: DashboardPage, beforeEnter: waitUser },
    { path: '/dashgo/:uid', beforeEnter: impersonateAndRedirect },
    { path: '/*', component: NotFoundPage },
  ],
  scrollBehavior : function(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

const isProd = (process.env.NODE_ENV === 'production')

if (!prerender.isInPrerender) {
  console.log('enabling GA')
  Vue.use(VueAnalytics, {
    id: 'UA-130104353-1', //media@pixxibook.com
    router,
    ecommerce: {
      enabled: true,
    },
    debug: {
      enabled: !isProd,
      sendHitTask: isProd,
    }
  })

  console.log('enabling GTM')
  Vue.use(VueGtm, {
    id: 'AW-784188118',
    debug: true,
    //vueRouter: router,
  });  
}

export default router




// WEBPACK FOOTER //
// ./src/router.js